import { VerifiableIdNumber } from "src/contexts/documentationArea/domain/VerifiableIdNumber";

export type ActorIdentityRepresentedEntityParams = {
  legalName: string | null;
  idNumbers: VerifiableIdNumber[];
  individualRelationType: string | null;
};

export class ActorIdentityRepresentedEntity {
  private legalName: string | null;
  private idNumbers: VerifiableIdNumber[];
  private individualRelationType: string | null;

  constructor({
    legalName,
    idNumbers,
    individualRelationType,
  }: ActorIdentityRepresentedEntityParams) {
    this.legalName = legalName;
    this.idNumbers = idNumbers || [];
    this.individualRelationType = individualRelationType;
  }

  public getLegalName() {
    return this.legalName;
  }

  public hasLegalName() {
    return this.hasValue(this.legalName);
  }

  public hasIndividualRelationType() {
    return this.hasValue(this.individualRelationType);
  }

  private hasValue(value?: string | null): boolean {
    return value !== null && value !== undefined && value.length > 0;
  }

  public getIdNumbers() {
    return this.idNumbers;
  }

  public hasIdNumber(): boolean {
    return this.idNumbers.length > 0;
  }

  public getIdNumber() {
    return this.idNumbers?.[0];
  }

  public getIndividualRelationType() {
    return this.individualRelationType;
  }
}
